<template>
  <v-dialog v-model="show" persistent max-width="320">
    <v-card>
      <v-card-title>
        <h3 class="subtitle-1">{{ $t('auth.LoginErrorDialogHeader') }}</h3>
      </v-card-title>
      <v-card-text v-html="$t('auth.LoginErrorDialogText')"></v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="closeDialog" >{{$t('auth.LoginErrorDialogButton')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: "LoginFailedDialog",
    props: ['show'],
    methods: {
      closeDialog() {
        this.$emit('closeDialog')
      }
    }
  }
</script>

<style>

</style>
